import React from 'react';
import { Box, Typography } from '@mui/material';

const Title = ({ title, subtitle }) => {
  return (
    <Box>
      <Typography
        sx={{
          fontFamily: 'var(--ft-h1-font-family)',
          letterSpacing: 'var(--ft-h1-letter-spacing)',
          fontSize: 'var(--ft-h1-font-size)',
          fontWeight: 'var(--ft-h1-font-weight)',
          lineHeight: 'var(--ft-h1-line-height)',
          color: 'var(--ft-white)'
        }}>
        {title}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            fontFamily: 'var(--ft-h3-font-family)',
            fontSize: 'var(--ft-h3-font-size)',
            letterSpacing: 'var(--ft-h3-letter-spacing)',
            fontWeight: 'var(--ft-h3-font-weight)',
            lineHeight: 'var(--ft-h3-line-height)',
            color: 'var(--ft-light-grey)'
          }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default Title;
